import CloseIcon from "@mui/icons-material/Close";
import { Box, Button, IconButton, TextField, Typography } from "@mui/material";
import { Modal } from "app/components/Modal";
import React from "react";
import { useTranslation } from "react-i18next";
import { useDispatch, useSelector } from "react-redux";

import {
  selectCanSubmitRoofMaterialType,
  selectIsAddModalOpen,
  selectRoofMaterialTypeForm,
  selectRoofMaterialTypeSaving,
} from "../../redux/selector";
import { roofMaterialTypeActions } from "../../redux/slice";
import { useStyles } from "./styles";

const P = "ROOF_MATERIAL_TYPE.MODAL";

const AddRoofMaterialModal = () => {
  const { t } = useTranslation();
  const styles = useStyles();
  const dispatch = useDispatch();
  const open = useSelector(selectIsAddModalOpen);
  const form = useSelector(selectRoofMaterialTypeForm);
  const saving = useSelector(selectRoofMaterialTypeSaving);
  const canSubmit = useSelector(selectCanSubmitRoofMaterialType);

  const onClose = () => {
    if (saving) return;
    dispatch(roofMaterialTypeActions.closeAddModal());
  };

  return (
    <Modal open={open} onClose={onClose}>
      <Box className={styles.modal}>
        <Box className={styles.header}>
          <Typography className={styles.title}>{t(`${P}.ADD_TITLE`)}</Typography>
          <IconButton
            className={styles.closeButton}
            onClick={onClose}
            aria-label={t("BUTTONS.CANCEL")}
            disabled={saving}
          >
            <CloseIcon />
          </IconButton>
        </Box>

        <Box className={styles.body}>
          <Box className={styles.field}>
            <Typography className={styles.label}>
              {t(`${P}.FIELDS.DESCRIPTION`)}
            </Typography>
            <TextField
              className={styles.input}
              fullWidth
              variant="outlined"
              placeholder={t(`${P}.PLACEHOLDERS.ENTER_DESCRIPTION`)}
              value={form.materialTypeDesc}
              disabled={saving}
              InputProps={{ notched: false }}
              onChange={(event) =>
                dispatch(
                  roofMaterialTypeActions.setFormField({
                    name: "materialTypeDesc",
                    value: event.target.value,
                  })
                )
              }
            />
          </Box>
        </Box>

        <Box className={styles.footer}>
          <Button
            className={styles.cancelButton}
            variant="outlined"
            onClick={onClose}
            disabled={saving}
          >
            {t("BUTTONS.CANCEL")}
          </Button>
          <Button
            className={styles.addButton}
            variant="contained"
            disableElevation
            disabled={!canSubmit || saving}
            onClick={() =>
              dispatch(roofMaterialTypeActions.addRoofMaterialType())
            }
          >
            {t("BUTTONS.ADD")}
          </Button>
        </Box>
      </Box>
    </Modal>
  );
};

export default AddRoofMaterialModal;
